import { render, staticRenderFns } from "./DmmPostcardTable.vue?vue&type=template&id=495fd146"
import script from "./DmmPostcardTable.vue?vue&type=script&lang=js"
export * from "./DmmPostcardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports